<!-- TEMPLATE -->
<template>
  <div class="content-container">
    <div class="row">
      <zoom-y-transition>
        <perfect-scrollbar
                v-show="!$store.getters.getLoadOverlay"
                class="small-0 medium-2 large-2 hd-2 columns ps-sidemenu"
                v-if="storedSideMenu && Object.keys(storedSideMenu).length"
        >
          <dean-sidemenu
                  class="sideMenu"
                  :data="storedSideMenu"
                  @dean-sidemenu-click="deanSidemenuRoute">
          </dean-sidemenu>
        </perfect-scrollbar>
      </zoom-y-transition>
      <zoom-y-transition>
        <perfect-scrollbar
                v-show="!$store.getters.getLoadOverlay"
                :options="{suppressScrollX:true}"
                :class="{
                'small-12': true,
                'medium-10': storedSideMenu && Object.keys(storedSideMenu).length,
                'large-10': storedSideMenu && Object.keys(storedSideMenu).length,
                'hd-10': storedSideMenu && Object.keys(storedSideMenu).length,
                'medium-12': storedSideMenu && Object.keys(storedSideMenu).length === 0,
                'large-12': storedSideMenu && Object.keys(storedSideMenu).length === 0,
                'hd-12': storedSideMenu && Object.keys(storedSideMenu).length === 0,
                'columns': true,
                'partners-content': true,
                'content': true,
                }">
          <router-view
                       :key="$route.fullPath"
          ></router-view>
        </perfect-scrollbar>
      </zoom-y-transition>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script lang='ts'>
  // VUE
  import Vue from 'vue';
  import { Component, Provide, Watch } from 'vue-property-decorator';
  import { deanDialogBus } from '@/main';
  import { ZoomYTransition, ZoomCenterTransition } from 'vue2-transitions';
  import { redirectToKeycloak } from '@/services/keycloak';

  import {
    // COMPONENTS
    deanSectionTitle,
    deanSectionTitleItem,
    deanSidemenu,
    invoicesIcon,
    commissionIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanSectionTitle,
      deanSectionTitleItem,
      deanSidemenu,
      invoicesIcon,
      commissionIcon,
      ZoomYTransition,
      ZoomCenterTransition,
    },
  })

  export default class Basic extends Vue {

    get storedSideMenu() {
      return this.$store.getters.getSideMenu;
    }

    // METHODS
    public deanSidemenuRoute(item: any) {
      if (item.keycloakAction) {
        // Account Console access is blocked (403/404) for non-admin users, so redirect
        // straight to Keycloak's password update action instead, with email prefilled.
        redirectToKeycloak(this.$store.getters.getUser.email, false, item.keycloakAction);
      } else if (item.params && item.params.modal) {
        deanDialogBus.$emit('open', item.name, item.params);
      } else {
        this.$router.push({name: item.name, params: item.params});
      }
    }

  }
</script>

<!-- STYLE -->
<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';

  .partners-content {
    background: white;
  }

  .content {
    overflow-y: hidden;
    height: calc(100vh - 80px);
  }

  .ps-sidemenu {
    height: calc(100vh - 80px);
    background: var(--color-light-shade-3, whitesmoke);
  }

  :deep(.dean-pagination) {
    padding-bottom: 0;

    :deep(.dean-pagination-container) {
      display: flex;
      align-items: center;
    }
  }
</style>
